import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetRolesDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Roles/GetDetail?` + params, null);

export const GetRolesList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Roles/GetList?` + params, null);

export const CreateUserGroup = (data: any) =>
  POST_ENC(`${BASE_URL}/api/UserGroup/Create`, data);

export const UpdateUserGroup = (data: any) =>
  POST_ENC(`${BASE_URL}/api/UserGroup/Update`, data);    

export const DeleteUserGroup = (data: any) =>
  POST_ENC(`${BASE_URL}/api/UserGroup/Delete`, data);






